import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    colorPrimary: 'rgba(31, 31, 31, 1)',
    // 基础配色
    colorText: 'rgba(31, 31, 31, 1)',
    // 第二梯度
    colorTextSecondary: 'rgba(105, 105, 105, 1)',
    // 选中的颜色
    controlItemBgActive: '#e6f4ff',
  },
  components: {
    Button: {
      colorPrimary: 'rgba(31, 31, 31, 1)',
      // algorithm: true
    },
    Tabs: {
      itemSelectedColor: 'rgba(31, 31, 31, 1)',
      inkBarColor: 'rgba(31, 31, 31, 1)',
      itemHoverColor: 'rgba(31, 31, 31, 1)',
    },
    Table: {
      controlItemBgHover: 'rgba(0, 0, 0, 0.08)',
      colorTextHeading: 'rgba(105, 105, 105, 1)',
    },
    Badge: {
      colorSuccess: 'var(--status-success)',
      colorError: 'var(--status-error)',
    },
  },
  
};
